//#region imports
import { Injectable } from '@angular/core';
import { AppConstants } from '../app.constants';
import { ContactDetailsRequestModel } from '../shared/model/contactdetails.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CharacteristicService } from './characteristic.service';
import { CharacteristicsComponentModel } from 'src/app/module/characteristics/components/characteristics.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DetailsComponentModel } from '../module/details/details.model';
import { DetailsService } from './details.service';
import { Globals } from './globals';
import { GuaranteeComponentModel } from '../module/guarantee/model/tarif.model';
import { GuaranteeService } from './guarantee.service';
import { Pricing, TheftModel, TarifCheckboxStatus } from '../module/guarantee/model/guarantee.model';
import { SummaryService } from './summary.service';
import { SectionService } from './section.service';
import { SignatureService } from './signature.service';
import { P5xService } from './p5x.service';
import { DocumentService } from './document.service';
import { SaveService } from './save.service';
import { TranslateService } from '@ngx-translate/core';
import { RecapitulatoryComponentModel, SimulationReservationReason } from '../module/recapitulatory/model/recapitulatory.model';
import { Signature4Answers, Signature5Answers, SaveCriteriaModel, SignatureComponentModel } from '../module/signature/model/signature.model';
import { DecimalPipe } from '@angular/common';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class RetrieveSimulationService {
  //#region variables
  rootLanguageURL: string;
  language: any;
  //#end regoin
  //#region methods
  constructor(
    private characteristicService: CharacteristicService, private detailsService: DetailsService,
    private guaranteeService: GuaranteeService, private summaryService: SummaryService,
    private httpClient: HttpClient, private global: Globals, private router: Router,
    private signatureService: SignatureService, private sectionService: SectionService,
    private p5xService: P5xService, private documentService: DocumentService,
    private decimalPipe: DecimalPipe,private route: ActivatedRoute,
    private saveService: SaveService, private translate: TranslateService) { }

  retrieveSimulationDetails(retrieveSimulationRequest: ContactDetailsRequestModel) {
    this.getRetrieveSimulationDetailsFromAPI(retrieveSimulationRequest).subscribe((retrieveResponse) => {
      this.characteristicService.setShowLandingPage(false);
      const simulationToken = retrieveSimulationRequest.SimulationToken;
      const simulationDetails = retrieveResponse.SimulationDetails;
      let sectionDetails = retrieveResponse.SectionDetails;
      sectionDetails = { Sections: sectionDetails };
      // console.log(sectionDetails);
      const customer = simulationDetails.Customer;
      const contactDetails = {
        FirstName: customer.FirstName, LastName: customer.LastName, Name: customer.Name, DateofBirth: customer.DateofBirth,
        EmailAddress: customer.emailaddress, Telephone: customer.telephone, PostalCode: customer.PostalCode, StreetName: customer.StreetName,
        StreetNumber: customer.StreetNumber, BoxNumber: customer.BoxNumber
      };

      this.saveService.setContactDetails(contactDetails);
      this.route.queryParams.subscribe((params) => {
        this.rootLanguageURL = params.language ? params.language : null;
      });

      if (simulationDetails !== undefined && simulationDetails !== null) {
        if (this.rootLanguageURL === simulationDetails.Language){
        this.language = simulationDetails.Language;}
        else{
          if(this.rootLanguageURL == undefined || this.rootLanguageURL == null)
          {
            this.language = simulationDetails.Language;
          }else{
          this.language = this.rootLanguageURL;}
        }
        if (this.language === null && this.language !== 'FR' && this.language !== 'NL') {
          this.language = this.guaranteeService.getLanguage();
        } else {
          this.translate.use(this.language);
          this.translate.setDefaultLang(this.language);
          this.global.languagecode = this.language;
          this.characteristicService.setDefaultLanguage(this.language);
          this.guaranteeService.setLanguage(this.language);
        }
        sessionStorage.setItem('language',this.language);
        const initialJSONData = {
          Channel: simulationDetails.Simulation.Channel,
          Language: this.language, Sections: retrieveResponse.SectionDetails,
          SimulationType: 'F', Status: 'In Progress', //retrieveResponse.SimulationDetails.Simulation.Status,
          CapitalUpdate: false
        };
        sessionStorage.setItem('jsonData', JSON.stringify(initialJSONData));

        const currentPage = simulationDetails.Simulation.CurrentPage;
        this.global.trackPageActivity = simulationDetails.Simulation.TrackActivity;
        
      if (simulationDetails.Simulation.SimulationStage.toUpperCase() === 'PROJECT SIGNED')
        {
          const input = {
            title: this.translate.instant('Msg_Error_Title'), 
            errorMessage: this.translate.instant('Msg_Simulation_Signed'),
            disableClose: true};
          this.characteristicService.serverFailError(input);
        }
      else if (simulationDetails.Simulation.SimulationStage.toUpperCase() === 'PROJECT DENIED')
      {
        const signatureComponent: SignatureComponentModel = {
          SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
          SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: false, SignatureRefuse: true
        };
        this.signatureService.setSignatureComponent(signatureComponent);
        this.router.navigate(['/signature'], { queryParams: { thankyou: 'true', language: this.language, status: 'reject' } });
      } 
      else if(simulationDetails.Simulation.SalesChannel == 'CRM')
        {
          const input = {
            title: this.translate.instant('Msg_Warning_Title'), 
            errorMessage: this.translate.instant('Msg_Simulation_CRMLocked'),
            disableClose: true};
          this.characteristicService.serverFailError(input);
        }

        // else if (simulationDetails.Simulation.SimulationStage.toUpperCase() === 'PROJECT RESERVED')
        // {
        //   const input = {
        //     title: this.translate.instant('Msg_Error_Title'), 
        //     errorMessage: this.translate.instant('Msg_Simulation_Projectreserved'),
        //     disableClose: false};
        //   this.characteristicService.serverFailError(input);
        // } 
        else
        {   
          if (simulationDetails.Simulation.SimulationStage.toUpperCase() === 'SIMULATION RESERVED'){
            this.saveService.setSimulationStatus('Simulation in Progress');
          } else {
            this.saveService.setSimulationStatus(simulationDetails.Simulation.SimulationStage);
          }
          if (simulationDetails.Customer.accountnumber !== null && simulationDetails.Customer.accountnumber !== undefined)
          {
            this.characteristicService.setClientIdOrSimulationTokenPresent(true);
            const fedURL = AppConstants.FederaleURL.MyFederale + this.language;
            this.global.federaleURL = fedURL;
            this.characteristicService.setFederaleURL(fedURL);
          }
          else{ 
            this.characteristicService.setClientIdOrSimulationTokenPresent(false);
              let urlparam = "";
              if(this.language ==='FR') {
                urlparam='/particulier'
              }else if(this.language ==='NL'){
                urlparam='/particulieren' 
              }
              const fedURL = AppConstants.FederaleURL.WWWFederale + this.language + urlparam;
              this.global.federaleURL = fedURL;
              
              this.characteristicService.setFederaleURL(fedURL);
          }
          this.redirectToCurrentPage(currentPage, simulationToken, sectionDetails, simulationDetails);
        }
      }
    }, (error) => {
      const input = {
        title: this.translate.instant('Msg_Error_Title'), 
        errorMessage: this.translate.instant('Msg_Simulation_Notexist'),
        disableClose: true};
      this.characteristicService.serverFailError(input);
      this.sectionService.setIsRetrieveSimulation(false);
      this.characteristicService.setClientIdOrSimulationTokenPresent(false);
      this.global.isClient = false;
      // this.router.navigate(['/characteristics']); 
    });
  }

  redirectToCurrentPage(currentPage: string, simulationToken, sectionDetails, simulationDetails) {
    this.getPostalLocationAndCountries();
    this.sectionService.setCurrentPage(currentPage);
    this.characteristicPreviousSelectedChoices(sectionDetails);
    const arr = currentPage.split('-');
    const currentSection = arr[0];
    const currentQuestion = arr[1];
    if (currentSection === 'P1') {
      this.characteristicSetGet(sectionDetails);
      this.characteristicService.setCharacteristicProgressBarDetails();
      if(this.global.isMobile)
      {this.characteristicService.setmobileCharacteristicProgressBarDetails();}
      this.redirectToCharacteristics(currentQuestion, simulationToken);
    } else if (currentSection === 'P21') {
      this.characteristicSetGet(sectionDetails);
      this.details2Point1SetGet(sectionDetails);
      this.detailsService.setDetailsProgressBarDetails();
      if(this.global.isMobile)
      {this.detailsService.setmobileDetailsProgressBarDetails();}
      this.redirectToDetailsSection2Point1(currentQuestion, simulationToken);
    } else if (currentSection === 'P22') {
      this.characteristicSetGet(sectionDetails);
      this.details2Point2SetGet(sectionDetails);
      this.detailsService.setDetailsProgressBarDetails();
      if(this.global.isMobile)
      {this.detailsService.setmobileDetailsProgressBarDetails();}
      this.redirectToDetailsSection2Point2(currentQuestion, simulationToken);
    } else if (currentSection === 'P3') {
      this.characteristicSetGet(sectionDetails);
      this.global.isContentFirsttime = true;
      const sectionKey = sectionDetails.Sections[1].SectionKey;
      (sectionKey === 'S2.1') ? this.details2Point1SetGet(sectionDetails) : this.details2Point2SetGet(sectionDetails);
      this.detailsService.setDetailsSection(sectionKey);
      const tarrification = simulationDetails.Tarrification;
      const evaluation = simulationDetails.Evaluation;
      this.guaranteeSetGet(sectionDetails, tarrification, evaluation, currentSection, simulationToken, currentQuestion,'', '');
      // this.redirectToGuarantee(currentQuestion, simulationToken);
    } else if (currentSection === 'P4') {
      if (currentQuestion === '2'){
        this.global.isContentFirsttime = true;
        this.characteristicSetGet(sectionDetails);
        const sectionKey = sectionDetails.Sections[1].SectionKey;
        (sectionKey === 'S2.1') ? this.details2Point1SetGet(sectionDetails) : this.details2Point2SetGet(sectionDetails);
        this.detailsService.setDetailsSection(sectionKey);
        const tarrification = simulationDetails.Tarrification;
        const evaluation = simulationDetails.Evaluation;
        const recapitulatoryComponent: RecapitulatoryComponentModel = {
          RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
        };
        this.summaryService.setRecapitulatoryComponent(recapitulatoryComponent);
        this.p5xService.setIsP5XPage(true);
        const appobject = Object.values(AppConstants.SimulationReservationReason)
            .filter(x => x.Text === simulationDetails.Simulation.Simulation_Reservation_Reason.toUpperCase());
        const simulationReservationReason: SimulationReservationReason = {
          ID: appobject[0].ID, Text: appobject[0].Text
        };
        this.p5xService.setSimulationReservationReason(simulationReservationReason);
        this.saveService.setSimulationStatus('Project Reserved');
        this.saveService.setProjectStatus('Project Reserved');
        this.p5xService.setDocumentGenerateStatus(true);
        this.guaranteeSetGet(sectionDetails, tarrification, evaluation, currentSection, simulationToken, currentQuestion, '', '');                
      }
      else {
        this.characteristicSetGet(sectionDetails);
        this.global.isContentFirsttime = true;
        const sectionKey = sectionDetails.Sections[1].SectionKey;
        (sectionKey === 'S2.1') ? this.details2Point1SetGet(sectionDetails) : this.details2Point2SetGet(sectionDetails);
        this.detailsService.setDetailsSection(sectionKey);
        const tarrification = simulationDetails.Tarrification;
        const evaluation = simulationDetails.Evaluation;
        const recapitulatoryComponent: RecapitulatoryComponentModel = {
          RecapitulatoryQuestion1: true, RecapitulatoryQuestion2: false
        };

        this.summaryService.setRecapitulatoryComponent(recapitulatoryComponent);
        this.guaranteeSetGet(sectionDetails, tarrification, evaluation, currentSection, simulationToken, currentQuestion, '', '');
        // this.redirectToSummary(simulationToken);
      }
    } else if (currentSection === 'P5') {
      this.global.isContentFirsttime = true;
      const signatureAddress = simulationDetails.Address;
      const signatureCriteria = simulationDetails.Criteria;
      this.characteristicSetGet(sectionDetails);
      const sectionKey = sectionDetails.Sections[1].SectionKey;
      (sectionKey === 'S2.1') ? this.details2Point1SetGet(sectionDetails) : this.details2Point2SetGet(sectionDetails);
      this.detailsService.setDetailsSection(sectionKey);
      this.signatureSetGet(simulationDetails);
      const tarrification = simulationDetails.Tarrification;
      const evaluation = simulationDetails.Evaluation;
      this.guaranteeSetGet(sectionDetails, tarrification, evaluation,currentSection, simulationToken, currentQuestion,signatureAddress, signatureCriteria);
      // this.redirectToSignature(currentQuestion, simulationToken, signatureAddress, signatureCriteria);
    }
    // console.log('Current Section: ' + currentSection + ', Current Question: ' + currentQuestion);
  }

  redirectToCharacteristics(currentQuestion: string, simulationTokenValue) {
    if (currentQuestion === '1') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(true, false, false, false, false);
    } else if (currentQuestion === '2') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, true, false, false, false);
    } else if (currentQuestion === '3') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, false, true, false, false);
    } else if (currentQuestion === '4') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, false, false, true, false);
    } else if (currentQuestion === '5') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, false, false, false, true);
    }
    this.router.navigate(['/characteristics'], { queryParams: { simulationToken: simulationTokenValue } });
  }

  characteristicSetGet(sectionDetails) {
    const answer1 = sectionDetails.Sections[0].QuestionGroup[0].Questions[0].Answers;
    if (answer1 !== null) {
      if (answer1[0].Answerkey === 'Taker_Type_Owner') {
        this.p5xService.setIsOwner(true);
        this.p5xService.setIsTakerOther(false);
        this.guaranteeService.setNaturePreneur('PROPR');
        this.guaranteeService.setNaturePreneurContenu('PROPR');
      } else if (answer1[0].Answerkey === 'Taker_Type_Renter') {
        this.p5xService.setIsOwner(false);
        this.p5xService.setIsTakerOther(false);
        this.guaranteeService.setNaturePreneur('LOCAT');
        this.guaranteeService.setNaturePreneurContenu('LOCAT');
      } else if (answer1[0].Answerkey === 'Taker_Type_Other') {
        this.p5xService.setIsOwner(false);
        this.p5xService.setIsTakerOther(true);
        this.guaranteeService.setNaturePreneur('OTHER');
      }
    }
    const answer2 = sectionDetails.Sections[0].QuestionGroup[1].Questions[0].Answers;
    if (answer2 !== null) {
      if (answer2[0].Answerkey === 'Property_Destination_Renting_YES') {
        if (this.p5xService.getIsOwner()) {
          this.guaranteeService.setNatureAutruiAbandonRecours('LOCAT');
        } else {
          this.guaranteeService.setNatureAutruiAbandonRecours('');
        }
        this.guaranteeService.setPropertyDestinationRenting(true);
      } else if (answer2[0].Answerkey === 'Property_Destination_Renting_NO') {
        this.guaranteeService.setNatureAutruiAbandonRecours('');
        this.guaranteeService.setPropertyDestinationRenting(false);
      }
    }
    const answer3 = sectionDetails.Sections[0].QuestionGroup[2].Questions[0].Answers;
    if (answer3 !== null) {
      if (answer3[0].Answerkey === 'Property_Type_House') {
        this.documentService.setIsHouse(true);
        this.documentService.setIsApartment(false);
        this.p5xService.setIsPropertyOther(false);
        this.guaranteeService.setpropertyType('MAISON');
        this.characteristicService.setSelectedHouse(true);
      } else if (answer3[0].Answerkey === 'Property_Type_Apartement') {
        this.documentService.setIsHouse(false);
        this.documentService.setIsApartment(true);
        this.p5xService.setIsPropertyOther(false);
        this.guaranteeService.setpropertyType('PARTIEBATI');
        this.characteristicService.setSelectedHouse(false);
      } else if (answer3[0].Answerkey === 'Property_Type_Building') {
        this.documentService.setIsHouse(false);
        this.documentService.setIsApartment(false);
        this.p5xService.setIsPropertyOther(true);
        this.guaranteeService.setpropertyType('');
      } else if (answer3[0].Answerkey === 'Property_Type_Other') {
        this.documentService.setIsHouse(false);
        this.documentService.setIsApartment(false);
        this.p5xService.setIsPropertyOther(true);
        this.guaranteeService.setpropertyType('');
      }
    }
    const answer4 = sectionDetails.Sections[0].QuestionGroup[3].Questions[0].Answers;
    if (answer4 !== null) {
      if (answer4[0].Answerkey === 'House_Number_Facades_2') {
        this.guaranteeService.setCodeTypeContiguite('2BATHAB');
      } else if (answer4[0].Answerkey === 'House_Number_Facades_3') {
        if (this.guaranteeService.getpropertyType() === 'MAISON') {
          this.guaranteeService.setCodeTypeContiguite('1BATHAB');
        } else {
          this.guaranteeService.setCodeTypeContiguite('2BATHAB');
        }
      } else if (answer4[0].Answerkey === 'House_Number_Facades_4') {
        if (this.guaranteeService.getpropertyType() === 'MAISON') {
          this.guaranteeService.setCodeTypeContiguite('AUTRE');
        } else {
          this.guaranteeService.setCodeTypeContiguite('2BATHAB');
        }
      }
    }
    const answer5 = sectionDetails.Sections[0].QuestionGroup[4].Questions[0].Answers;
    if (answer5 !== null) {
      if (answer5[0].Answerkey === 'Property_Residence_Type_Principal') {
        this.p5xService.setSecondaryResidence(false);
        this.guaranteeService.setResidencePrinciple('true');
      } else if (answer5[0].Answerkey === 'Property_Residence_Type_Second') {
        this.p5xService.setSecondaryResidence(true);
        this.guaranteeService.setResidencePrinciple('false');
      }
    }
    this.signatureService.getData().subscribe((data) => {
      const signatureData = data;
      sessionStorage.setItem('signatureData', JSON.stringify(signatureData));
    });
    const minpre = this.guaranteeService.getMinimumPremium();
    if (minpre === null || minpre === undefined ){
    this.guaranteeService.getMinPremiumFromAPI().subscribe((response) => {
      this.guaranteeService.setMinimumPremium(response);
    });
    }



  }

  details2Point1SetGet(sectionDetails) {
    this.documentService.setHouseAttic(false);
    this.documentService.setHouseOrApartmentNatureFlooring(false);
    const postCodeAnswer = sectionDetails.Sections[1].QuestionGroup[3].Questions[0].Answers;
    if (postCodeAnswer !== null){
      const postCode = postCodeAnswer[0].AnswerText;
      if (postCode.length > 0)
      {
        this.guaranteeService.setPostalCode(postCode);
        this.global.propertyPostCode = postCode;
      }
    }
    const answer1 = sectionDetails.Sections[1].QuestionGroup[1].Questions[0].Answers;
    if (answer1 !== null) {
      const answer11 = answer1.filter(obj => obj.Answerkey === 'House_Attic_Question');
      if (answer11.length > 0) {
        this.documentService.setHouseAttic(true);
      }
      const answer12 = answer1.filter(obj => obj.Answerkey === 'House_Nature_Question');
      if (answer12.length > 0) {
        this.documentService.setHouseOrApartmentNatureFlooring(true);
      }
    }
    const answer2 = sectionDetails.Sections[1].QuestionGroup[4].Questions[0].Answers;
    if (answer2 !== null) {
      const answer21 = answer2.filter(obj => obj.Answerkey === 'House_Property_Annex_More_50_Question');
      const answer22 = answer2.filter(obj => obj.Answerkey === 'House_Property_Classified_Question');
      const answer23 = answer2.filter(obj => obj.Answerkey === 'House_Property_Empty_Question');
      const answer24 = answer2.filter(obj => obj.Answerkey === 'House_Property_Indoor_Pool_Question');
      const answer25 = answer2.filter(obj => obj.Answerkey === 'House_Property_Professional_Use_Question');
      const answer26 = answer2.filter(obj => obj.Answerkey === 'House_Property_To_Be_Demolished_Question');
      const answer27 = answer2.filter(obj => obj.Answerkey === 'House_Property_To_Be_Renovated_Question');
      if (answer21.length > 0 || answer22.length > 0 || answer26.length > 0 || answer27.length > 0) {
        this.p5xService.setP215AcceptanceCriteria(true);
      } else {
        this.p5xService.setP215AcceptanceCriteria(false);
      }
      if (answer23.length > 0 || answer24.length > 0 || answer25.length > 0) {
        this.p5xService.setP215GridCriteriaChecked(true);
      } else {
        this.p5xService.setP215GridCriteriaChecked(false);
      }
    }

    const tele = sectionDetails.Sections[1].QuestionGroup[5].Questions[2].Answers;
    const eml = sectionDetails.Sections[1].QuestionGroup[5].Questions[3].Answers;

    if (tele !== null && eml !== null){

      const custdet = this.saveService.getContactDetails();
      const contactDetails = {
        FirstName: custdet.FirstName, LastName: custdet.LastName, Name: custdet.Name, DateofBirth: custdet.DateofBirth,
        EmailAddress: sectionDetails.Sections[1].QuestionGroup[5].Questions[3].Answers[0].AnswerText, 
        Telephone: sectionDetails.Sections[1].QuestionGroup[5].Questions[2].Answers[0].AnswerText, 
        PostalCode: custdet.PostalCode, StreetName: custdet.StreetName,
        StreetNumber: custdet.StreetNumber, BoxNumber: custdet.BoxNumber
      };
      this.saveService.setContactDetails(contactDetails);
    }

  }

  signatureSetGet(simulationDetails) {

    if (simulationDetails.Address) {
      sessionStorage.setItem('signatureData', JSON.stringify(simulationDetails.Address));
      this.global.paymentFrequencyanswer = simulationDetails.Address.Premium_Frequency_paiement;
      this.signatureService.setPropertyPostalCode(simulationDetails.Address.Taker_Address_Post_Code);
    }
    if (simulationDetails.Criteria) {
      const signature4Answers: Signature4Answers = {
        FirstCheckbox: simulationDetails.Criteria.Criteria_sinistrality, 
        SecondCheckbox: simulationDetails.Criteria.Criteria_cancellation_other_company, 
        ThirdCheckbox: simulationDetails.Criteria.Criteria_never_insured_property,
        FourthCheckbox: simulationDetails.Criteria.Criteria_bankrupty, 
        RequirementText: simulationDetails.Criteria.Taker_specific_requirement
      };
      this.signatureService.setSignature4Answers(signature4Answers);

      const signature5Answers: Signature5Answers = {
        Sales_Office: simulationDetails.Criteria.Sales_office,
        ID_IMD: simulationDetails.Criteria.ID_IMD,
        Lattidude: simulationDetails.Criteria.Lattidude,
        Longitude: simulationDetails.Criteria.Longitude        
      };
      this.signatureService.setSignature5Answers(signature5Answers);

      const saveCriteria: SaveCriteriaModel = {
        Criteria_sinistrality: simulationDetails.Criteria.Criteria_bankrupty,
        Criteria_cancellation_other_company: simulationDetails.Criteria.Criteria_cancellation_other_company,
        Criteria_never_insured_property: simulationDetails.Criteria.Criteria_never_insured_property,
        Criteria_bankrupty: simulationDetails.Criteria.Criteria_sinistrality, 
        Taker_specific_requirement: simulationDetails.Criteria.Taker_specific_requirement ?
        simulationDetails.Criteria.Taker_specific_requirement : '',
        Sales_office: simulationDetails.Criteria.Sales_office,
        ID_IMD: simulationDetails.Criteria.ID_IMD,
        Longitude: simulationDetails.Criteria.Longitude,
        Lattidude: simulationDetails.Criteria.Lattidude,
        FNICEFile: simulationDetails.Criteria.FNICEFile,
        NoClient: simulationDetails.Criteria.NoClient,
        OfferDocPath: null
      };
      this.signatureService.setSaveCriteria(saveCriteria);
      this.documentService.fniceNo = simulationDetails.Criteria.FNICEFile;
      if (simulationDetails.Criteria.FNICEFile !== undefined && simulationDetails.Criteria.FNICEFile !== null) {
        this.signatureService.getPdfBytesFromFilePath(simulationDetails.Criteria.FNICEFile).subscribe((response) => {
          this.documentService.pdfDocument = response.PDFBytes;
        });
      }
    }
  }

  details2Point2SetGet(sectionDetails) {
    this.documentService.setHouseOrApartmentNatureFlooring(false);
    this.p5xService.setP223IndoorPoolChecked(false);
    const postCodeAnswer = sectionDetails.Sections[1].QuestionGroup[3].Questions[0].Answers;
    if (postCodeAnswer !== null){
      const postCode = postCodeAnswer[0].AnswerText;
      if (postCode.length > 0)
      {
        this.guaranteeService.setPostalCode(postCode);
        this.global.propertyPostCode = postCode;
      }
    }
    const answer1 = sectionDetails.Sections[1].QuestionGroup[1].Questions[0].Answers;
    if (answer1 !== null) {
      const answer11 = answer1.filter(obj => obj.Answerkey === 'Apartment_Nature_Flooring_Question');
      if (answer11.length > 0) {
        this.documentService.setHouseOrApartmentNatureFlooring(true);
      }
    }
    const answer2 = sectionDetails.Sections[1].QuestionGroup[2].Questions[0].Answers;
    if (answer2 !== null) {
      const answer21 = answer2.filter(obj => obj.Answerkey === 'Apartment_Indoor_Pool_Question');
      if (answer21.length > 0) {
        this.p5xService.setP223IndoorPoolChecked(true);
      }
    }
    const answer3 = sectionDetails.Sections[1].QuestionGroup[4].Questions[0].Answers;
    if (answer3 !== null) {
      const answer31 = answer3.filter(obj => obj.Answerkey === 'Apartment_Property_Empty_Question');
      const answer32 = answer3.filter(obj => obj.Answerkey === 'Apartment_Property_Classified_Question');
      const answer33 = answer3.filter(obj => obj.Answerkey === 'Apartment_Property_Professional_Use_Question');
      const answer34 = answer3.filter(obj => obj.Answerkey === 'Apartment_Property_To_Be_Demolished_Question');
      const answer35 = answer3.filter(obj => obj.Answerkey === 'Apartment_Property_To_Be_Renovated_Question');
      if (answer31.length > 0 || answer32.length > 0 || answer34.length > 0 || answer35.length > 0) {
        this.p5xService.setP225AcceptanceCriteria(true);
      } else {
        this.p5xService.setP225AcceptanceCriteria(false);
      }
      if (answer33.length > 0) {
        this.p5xService.setP225GridCriteriaChecked(true);
      } else {
        this.p5xService.setP225GridCriteriaChecked(false);
      }
    }

    const tele = sectionDetails.Sections[1].QuestionGroup[5].Questions[2].Answers;
    const eml = sectionDetails.Sections[1].QuestionGroup[5].Questions[3].Answers;

    if (tele !== null && eml !== null){

      const custdet = this.saveService.getContactDetails();
      const contactDetails = {
        FirstName: custdet.FirstName, LastName: custdet.LastName, Name: custdet.Name, DateofBirth: custdet.DateofBirth,
        EmailAddress: sectionDetails.Sections[1].QuestionGroup[5].Questions[3].Answers[0].AnswerText, 
        Telephone: sectionDetails.Sections[1].QuestionGroup[5].Questions[2].Answers[0].AnswerText, 
        PostalCode: custdet.PostalCode, StreetName: custdet.StreetName,
        StreetNumber: custdet.StreetNumber, BoxNumber: custdet.BoxNumber
      };
      this.saveService.setContactDetails(contactDetails);
    }

  }

  guaranteeSetGet(sectionDetails, tarificationDetails, evaluationDetails,currentSection, simulationToken, currentQuestion,signatureAddress, signatureCriteria) {
    // this.guaranteeService.setContentCovering(true);
    this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
    this.guaranteeService.setExecuteTarification(false);
    this.guaranteeService.setUpdateEnsuringContentCheck(false);
    this.guaranteeService.setBtnCalculateClickedChk(false);
    
    if (tarificationDetails.Premium_VAT_Fire_Content_Checked){
      this.guaranteeService.setContentCovering(true);
    }
    else{
      this.guaranteeService.setContentCovering(false);
    }    
    if (tarificationDetails.Premium_Amount_VAT_Waiver_Of_Recourse_Checked){
      this.guaranteeService.setNatureAbandonRecoursCheck(true);
    }
    else{
      this.guaranteeService.setNatureAbandonRecoursCheck(false);
    }    
    if (this.documentService.getIsHouse()) {
    const postcode = sectionDetails.Sections.find(obj => obj.SectionKey === 'S2.1').QuestionGroup.find(obj => obj.GroupKey === 'G9')
      .Questions.find(obj => obj.QuestionKey === 'House_Property_Post_Code_Question').Answers;
    this.guaranteeService.setPostalCode(postcode[0].AnswerText);
    } else {
      const postcode = sectionDetails.Sections.find(obj => obj.SectionKey === 'S2.2').QuestionGroup.find(obj => obj.GroupKey === 'G15')
        .Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question').Answers;
      this.guaranteeService.setPostalCode(postcode[0].AnswerText);
    }
    if (tarificationDetails.Premium_Amount_VAT_Theft_Checked)
    {
      this.p5xService.setTheftChecked(true);
      this.p5xService.setP41TheftChecked(true);
    }
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.global.isMobile && currentQuestion !== '2')
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    const tarifCheckboxStatus: TarifCheckboxStatus = {
      Premium_VAT_Fire_Content_Checked: tarificationDetails.Premium_VAT_Fire_Content_Checked,
      Premium_Amount_VAT_Legal_Protection_Checked: tarificationDetails.Premium_Amount_VAT_Legal_Protection_Checked,
      Premium_Amount_VAT_Theft_Checked: tarificationDetails.Premium_Amount_VAT_Theft_Checked,
      Premium_Amount_VAT_Theft_WithAlarm_Checked: tarificationDetails.Premium_Amount_VAT_Theft_WithAlarm_Checked,
      Premium_Amount_VAT_Deductible_Refund_Checked: tarificationDetails.Premium_Amount_VAT_Deductible_Refund_Checked,
      Premium_Amount_VAT_Indirect_Losses_Checked: tarificationDetails.Premium_Amount_VAT_Indirect_Losses_Checked,
      Premium_Amount_VAT_Waiver_Of_Recourse_Checked: tarificationDetails.Premium_Amount_VAT_Waiver_Of_Recourse_Checked
    };
    this.guaranteeService.setTarifCheckboxStatus(tarifCheckboxStatus);
    const pricingData: Pricing = { Tarification: tarificationDetails, Evaluation: evaluationDetails };
    const tarificationCapitalContenuEvalue = tarificationDetails.CapitalContenuEvalue;
    const evaluationCapitalContenuEvalue = evaluationDetails.CapitalContenuEvalue;
    const initialJSONData = JSON.parse(sessionStorage.getItem('jsonData'));
    if (tarificationCapitalContenuEvalue === evaluationCapitalContenuEvalue) {
      if (tarificationDetails.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
        this.guaranteeService.setInitialPricingData(pricingData);
        this.guaranteeService.getTarificationEvaluationApi(initialJSONData).subscribe((response) => {
          this.guaranteeService.setTarificationValues(response);
          this.guaranteeService.setInitialPricingData(pricingData);
          this.guaranteeService.setPremiumTotalAmount(pricingData.Tarification.Premium_Total_Amount);
          if (currentSection === 'P3'){
            this.redirectToGuarantee(currentQuestion, simulationToken);
          } else if(currentSection === 'P4') {
            this.redirectToSummary(simulationToken, currentQuestion);
          } else if(currentSection === 'P5') {
            this.redirectToSignature(currentQuestion, simulationToken, signatureAddress, signatureCriteria);
          }
        });
      } else {
        this.guaranteeService.setInitialPricingData(pricingData);
        this.guaranteeService.getTarificationEvaluationApi(initialJSONData).subscribe((response) => {
          this.guaranteeService.setTarificationValues(response);
          const theftObj: TheftModel = {
            Premium_Amount_VAT_Theft: tarificationDetails.Premium_Amount_VAT_Theft,
            Premium_Amount_VAT_Theft_Net: tarificationDetails.Premium_Amount_VAT_Theft_Net,
            Premium_Amount_VAT_Theft_Tax: tarificationDetails.Premium_Amount_VAT_Theft_Tax,
            Premium_Amount_VAT_Theft_Acquisition: tarificationDetails.Premium_Amount_VAT_Theft_Acquisition,
            Premium_Amount_VAT_Theft_Administration: tarificationDetails.Premium_Amount_VAT_Theft_Administration
          };
          this.guaranteeService.setInitialPricingData(pricingData);
          this.guaranteeService.setFlightSubject(theftObj);
          this.guaranteeService.setBackupFlight(theftObj);
          if (currentSection === 'P3'){
            this.redirectToGuarantee(currentQuestion, simulationToken);
          } else if(currentSection === 'P4') {
            this.redirectToSummary(simulationToken, currentQuestion);
          } else if(currentSection === 'P5') {
            this.redirectToSignature(currentQuestion, simulationToken, signatureAddress, signatureCriteria);
          }
        });
      }
    } else {
            const capitalBatiment30Percent = (30 / 100) * evaluationDetails.CapitalBatimentEvalue.replace(',','.');
            const percent30MoreThanCapital = + (this.decimalPipe.transform(capitalBatiment30Percent, '0.2-2').replace(',', ''));

            const capitalContentValue = Math.round(+(tarificationCapitalContenuEvalue.replace(',', '.')));
            if (capitalContentValue > percent30MoreThanCapital) {
              this.p5xService.setContentCapital(true);
            } else {
              this.p5xService.setContentCapital(false);
            }

            if (tarificationDetails.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
              this.guaranteeService.getTarificationEvaluationApi(initialJSONData).subscribe((response) => {
                this.guaranteeService.setTarificationValues(response);
                // const request = this.guaranteeService.updateTarifRequest('false', tarificationDetails.CapitalContenuEvalue);
                const request = this.guaranteeService.updateTarifRequest('true', tarificationDetails.CapitalContenuEvalue);
                this.guaranteeService.getUpdatedTarificationEvaluationApi(request).subscribe((response2) => {
                  this.guaranteeService.updateTarifEnsuringContentCalculation(tarificationDetails.CapitalContenuEvalue, response2);
                  if (currentSection === 'P3'){
                    this.redirectToGuarantee(currentQuestion, simulationToken);
                  } else if(currentSection === 'P4') {
                    this.redirectToSummary(simulationToken, currentQuestion);
                  } else if(currentSection === 'P5') {
                    this.redirectToSignature(currentQuestion, simulationToken, signatureAddress, signatureCriteria);
                  }
                });
        });
      } else {
        this.guaranteeService.getTarificationEvaluationApi(initialJSONData).subscribe((response) => {
          this.guaranteeService.setTarificationValues(response);
          this.guaranteeService.setUpdatedPricingData(pricingData);
          const theftObj: TheftModel = {
            Premium_Amount_VAT_Theft: tarificationDetails.Premium_Amount_VAT_Theft,
            Premium_Amount_VAT_Theft_Net: tarificationDetails.Premium_Amount_VAT_Theft_Net,
            Premium_Amount_VAT_Theft_Tax: tarificationDetails.Premium_Amount_VAT_Theft_Tax,
            Premium_Amount_VAT_Theft_Acquisition: tarificationDetails.Premium_Amount_VAT_Theft_Acquisition,
            Premium_Amount_VAT_Theft_Administration: tarificationDetails.Premium_Amount_VAT_Theft_Administration
          };
          this.guaranteeService.setBackupUpdatedFlight(theftObj);
          if (currentSection === 'P3'){
            this.redirectToGuarantee(currentQuestion, simulationToken);
          } else if(currentSection === 'P4') {
            this.redirectToSummary(simulationToken, currentQuestion);
          } else if(currentSection === 'P5') {
            this.redirectToSignature(currentQuestion, simulationToken, signatureAddress, signatureCriteria);
          }
        });
      }
    }
  }

  characteristicPreviousSelectedChoices(sectionDetails) {
    const previousQuestionsList = [];
    const tmpArr = [];
    const questionGroups = sectionDetails.Sections[0].QuestionGroup;
    for (const questionGroup of questionGroups) {
      if (tmpArr.length === 0) {
        const groupKey = questionGroup.GroupKey;
        const question = questionGroup.Questions[0];
        const questionID = question.QuestionId;
        const answer = question.Answers;
        if (answer !== undefined && answer !== null) {
          let previousQuestionID = '';
          const choiceID = answer[0].Answerkey;
          if (questionID === 1) {
            previousQuestionID = null;
          }
          const choices = question.QuestionChoices;
          for (const choice of choices) {
            const choiceKey = choice.ChoiceKey;
            if (choiceKey === choiceID) {
              tmpArr.push(choice.NextQuestionId);
            }
          }
          const selectedChoice = { choiceId: choiceID, GroupKey: groupKey, questionId: questionID, previousQuestionId: previousQuestionID };
          previousQuestionsList.push(selectedChoice);
          sessionStorage.setItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList, JSON.stringify(previousQuestionsList));
        }
      } else {
        const questionID1 = tmpArr[tmpArr.length - 1];
        for (const questionGroup1 of questionGroups) {
          const questionID2 = questionGroup1.Questions[0].QuestionId;
          if (questionID1 === questionID2) {
            const groupKey1 = questionGroup1.GroupKey;
            const question1 = questionGroup1.Questions[0];
            const answer = question1.Answers;
            if (answer !== undefined && answer !== null) {
              let previousQuestionID = '';
              const choiceID = answer[0].Answerkey;
              if (questionID2 === 1) {
                previousQuestionID = null;
              }
              const choices = question1.QuestionChoices;
              for (const choice of choices) {
                const choiceKey = choice.ChoiceKey;
                if (choiceKey === choiceID) {
                  tmpArr.push(choice.NextQuestionId);
                }
              }
              const selectedChoice = {
                choiceId: choiceID, GroupKey: groupKey1, questionId: questionID2,
                previousQuestionId: previousQuestionsList[previousQuestionsList.length - 1].questionId
              };
              this.characteristicService.setCharacteristicGroupKey(groupKey1);
              previousQuestionsList.push(selectedChoice);
              sessionStorage.setItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList, JSON.stringify(previousQuestionsList));
            }
          }
        }
      }
    }
  }

  redirectToDetailsSection2Point1(currentQuestion: string, simulationTokenValue) {
    if (currentQuestion === '1') {
      this.detailsService.setDetailsCurrentPage(true, false, false, false, false, false,
        false, false, false, false, false, false);
    } else if (currentQuestion === '2') {
      this.detailsService.setDetailsCurrentPage(false, true, false, false, false, false,
        false, false, false, false, false, false);
    } else if (currentQuestion === '3') {
      this.detailsService.setDetailsCurrentPage(false, false, true, false, false, false,
        false, false, false, false, false, false);
    } else if (currentQuestion === '4') {
      this.detailsService.setDetailsCurrentPage(false, false, false, true, false, false,
        false, false, false, false, false, false);
    } else if (currentQuestion === '5') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, true, false,
        false, false, false, false, false, false);
    } else if (currentQuestion === '6') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, true,
        false, false, false, false, false, false);
    }
    this.detailsService.setDetailsSection('S2.1');
    this.detailsService.setDetailsProgressBarDetails();
    if(this.global.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.router.navigate(['/details'], { queryParams: { simulationToken: simulationTokenValue } });
  }

  redirectToDetailsSection2Point2(currentQuestion: string, simulationTokenValue) {
    if (currentQuestion === '1') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        true, false, false, false, false, false);
    } else if (currentQuestion === '2') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, true, false, false, false, false);
    } else if (currentQuestion === '3') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, true, false, false, false);
    } else if (currentQuestion === '4') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, false, true, false, false);
    } else if (currentQuestion === '5') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, false, false, true, false);
    } else if (currentQuestion === '6') {
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, false, false, false, true);
    }
    this.detailsService.setDetailsSection('S2.2');
    this.detailsService.setDetailsProgressBarDetails();
    if(this.global.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.router.navigate(['/details'], { queryParams: { simulationToken: simulationTokenValue } });
  }

  redirectToGuarantee(guaranteeCurrentPage: string, simulationTokenValue) {
    if (guaranteeCurrentPage === '1') {
      this.guaranteeService.setGuaranteeCurrentPage(true, false, false, false, false);
    } else if (guaranteeCurrentPage === '2') {
      this.guaranteeService.setGuaranteeCurrentPage(false, true, false, false, false);
    } else if (guaranteeCurrentPage === '3') {
      this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
    } else if (guaranteeCurrentPage === '4') {
      this.guaranteeService.setGuaranteeCurrentPage(false, false, false, true, false);
    } else if (guaranteeCurrentPage === '5') {
      this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);
    }
    this.router.navigate(['/guarantee'], { queryParams: { simulationToken: simulationTokenValue } });
  }

  redirectToSummary(simulationTokenValue, currentpage) {
    if (currentpage === '2') {
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      this.p5xService.setDisableP5XPrevious(true);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
      this.global.p5xPrvDisable = true;
    }
    else {    
      this.summaryService.setRecapitulatoryCurrentPage(true, false);
    }
    this.router.navigate(['/recapitulatory'], { queryParams: { simulationToken: simulationTokenValue } });
  }

  redirectToSignature(signatureCurrentPage: string, simulationTokenValue, signatureAddress, signatureCriteria) {
    this.signatureService.setSaveAddress1(signatureAddress);
    if (signatureCurrentPage === '1') {
      this.signatureService.showPrevSignature = false;
      this.signatureService.setSignatureCurrentPage(true, false, false, false, false, false, false, false);
    } else if (signatureCurrentPage === '2') {
      this.signatureService.showPrevSignature = true;
      this.signatureService.setSignatureCurrentPage(false, true, false, false, false, false, false, false);
    } else if (signatureCurrentPage === '3') {
      this.signatureService.showPrevSignature = true;
      this.signatureService.setSignatureCurrentPage(false, false, true, false, false, false, false, false);
    } else if (signatureCurrentPage === '4') {
      this.signatureService.showPrevSignature = true;
      this.signatureService.setSaveCriteria(signatureCriteria);
      this.signatureService.setSignatureCurrentPage(false, false, false, true, false, false, false, false);
    } else if (signatureCurrentPage === '5') {
      this.signatureService.showPrevSignature = false;
      this.signatureService.setSaveCriteria(signatureCriteria);
      this.signatureService.setSignatureCurrentPage(false, false, false, false, true, false, false, false);
    }else if (signatureCurrentPage === '6') {
        this.signatureService.showPrevSignature = false;
        this.signatureService.setSignatureCurrentPage(false, false, false, false, false, true, false, false);
    }
    this.router.navigate(['/signature'], { queryParams: { simulationToken: simulationTokenValue } });
  }

  getPostalLocationAndCountries() {
    this.detailsService.getLocation().subscribe((data) => {
      this.global.locationData = data;
      this.detailsService.getCountry().subscribe((data1) => {
        this.global.countryData = data1;
      });
    });
  }

  getRetrieveSimulationDetailsFromAPI(retrieveSimulationRequest: ContactDetailsRequestModel) {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      return this.httpClient.get<any>(AppConstants.MockURLS.RetrieveSimulation);
    } else {
      const url = environment.apiURL + AppConstants.APIURLS.RetrieveSimulation;
      return this.httpClient.post<any>(url, retrieveSimulationRequest);
    }
  }
  //#endregion
}
